<template>
  <div>
    <b-row v-if="loading">
      <b-col cols="12">
        <loading-card />
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col
        cols="12"
        md="7"
      >
        <b-row>
          <b-col cols="12">
            <default-card
              title="Genel Toplam"
              :value="lastMonth.grandTotals.lastMonth"
              :totals="lastMonth.grandTotals.today"
              icon="RepeatIcon"
              color="success"
            />
          </b-col>
          <b-col
            v-for="item in lastMonth.data"
            :key="item.id"
            cols="12"
            md="12"
          >
            <default-card
              :title="item.title"
              :value="item.data.lastMonth"
              :totals="item.data.today"
              icon="RepeatIcon"
              color="info"
            />
          </b-col>
        </b-row>
      </b-col>
      <b-col
        cols="12"
        md="5"
      >
        <pie-charts
          :series-data="lastMonth.grandTotals.chartData.totalChart.series"
          :categories-data="lastMonth.grandTotals.chartData.totalChart.labels"
          chart-type="donut"
          chart-title="Devreden Stoklar"
        />
        <pie-charts
          :series-data="lastMonth.grandTotals.chartData.detailTotal.series"
          :categories-data="lastMonth.grandTotals.chartData.detailTotal.labels"
          chart-type="donut"
          chart-title="Markalara Göre"
        />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { BCol, BRow } from 'bootstrap-vue'
import LoadingCard from '@/layouts/components/Loading.vue'
import DefaultCard from '@/layouts/components/ReportCards/DefaultCard.vue'
import PieCharts from '@/layouts/components/ReportCharts/PieCharts.vue'

export default {
  name: 'LastMonthStocks',
  components: {
    DefaultCard, LoadingCard, BCol, BRow, PieCharts,
  },
  computed: {
    loading() {
      return this.$store.getters['saleStocksReports/loading']
    },
    lastMonth() {
      return this.$store.getters['saleStocksReports/lastMonth']
    },
  },
  created() {
    this.getLastMonth()
  },
  methods: {
    getLastMonth() {
      this.$store.dispatch('saleStocksReports/getLastMonth')
    },
  },
}
</script>
